<div id="fullscreenLoaderOverlay" style="zoom: 1;" *ngIf="visible">
</div>
<div id="fullscreenLoaderMessage" class="card " *ngIf="visible">
    <div class="card-body">
        <div class="text-centered my-2">
            <h5>{{message}}<img src="images/loader.gif"/></h5>
        </div>
    </div>
</div>
